!function() {
  class t {
    constructor(t = 20) {
      this.margin = t;
    }
    calculateOptimalPosition(t, e) {
      if (!t || !e) return null;
      const i = t.getBoundingClientRect(), s = {
        width: window.innerWidth,
        height: window.innerHeight,
        scrollX: window.scrollX,
        scrollY: window.scrollY
      }, o = {
        top: i.top + s.scrollY,
        left: i.left + s.scrollX,
        right: i.right + s.scrollX,
        bottom: i.bottom + s.scrollY,
        width: i.width,
        height: i.height
      }, n = [ "bottom-left", "left", "bottom", "top", "right" ];
      for (const t of n) {
        const i = this.getPositionCoords(t, o, e);
        if (this.fitsInViewport(i, e, s)) return {
          position: t,
          x: i.x,
          y: i.y
        };
      }
      return this.getFallbackPosition(o, e, s);
    }
    _checkOverlap(t, e) {
      return !(t.x + t.width < e.left || e.right < t.x || t.y + t.height < e.top || e.bottom < t.y);
    }
    getPositionCoords(t, e, i) {
      const {width: s, height: o} = i;
      let n, h;
      switch (t) {
       case "bottom-left":
        n = e.left, h = e.bottom + this.margin;
        break;

       case "bottom":
        n = e.left + e.width / 2 - s / 2, h = e.bottom + this.margin;
        break;

       case "top":
        n = e.left + e.width / 2 - s / 2, h = e.top - o - this.margin;
        break;

       case "right":
        n = e.right + this.margin, h = e.top + e.height / 2 - o / 2;
        break;

       case "left":
        {
          n = e.left - s - this.margin;
          const t = {
            width: window.innerWidth,
            height: window.innerHeight,
            scrollY: window.scrollY
          };
          let i = e.top - t.scrollY + e.height / 2 - o / 2;
          const a = t.height - o, r = 0;
          h = Math.max(r, Math.min(i, a));
          break;
        }
      }
      return {
        x: n,
        y: h
      };
    }
    fitsInViewport(t, e, i) {
      const {x: s, y: o} = t, {width: n, height: h} = e;
      return s >= 0 && o >= 0 && s + n <= i.width && o + h <= i.height + i.scrollY;
    }
    getFallbackPosition(t, e, i) {
      const {width: s, height: o} = e, n = {
        top: t.top - i.scrollY,
        left: t.left - i.scrollX,
        right: t.right - i.scrollX,
        bottom: t.bottom - i.scrollY,
        width: t.width,
        height: t.height
      };
      let h, a, r;
      if (n.left >= s + this.margin) h = n.left - s - this.margin, a = Math.max(0, Math.min(n.top + n.height / 2 - o / 2, i.height - o)), 
      r = "left-centered"; else if (n.right + s + this.margin <= i.width) h = n.right + this.margin, 
      a = Math.max(0, Math.min(n.top + n.height / 2 - o / 2, i.height - o)), r = "right-centered"; else if (n.top >= o + this.margin) h = Math.max(0, Math.min(n.left + n.width / 2 - s / 2, i.width - s)), 
      a = n.top - o - this.margin, r = "top-centered"; else if (n.bottom + o + this.margin <= i.height) h = Math.max(0, Math.min(n.left + n.width / 2 - s / 2, i.width - s)), 
      a = n.bottom + this.margin, r = "bottom-centered"; else {
        const t = n.left + n.width / 2, e = n.top + n.height / 2, l = [ {
          name: "top-left",
          x: 0,
          y: 0,
          distance: Math.sqrt(Math.pow(t, 2) + Math.pow(e, 2))
        }, {
          name: "top-right",
          x: Math.max(0, i.width - s),
          y: 0,
          distance: Math.sqrt(Math.pow(i.width - t, 2) + Math.pow(e, 2))
        }, {
          name: "bottom-left",
          x: 0,
          y: Math.max(0, i.height - o),
          distance: Math.sqrt(Math.pow(t, 2) + Math.pow(i.height - e, 2))
        }, {
          name: "bottom-right",
          x: Math.max(0, i.width - s),
          y: Math.max(0, i.height - o),
          distance: Math.sqrt(Math.pow(i.width - t, 2) + Math.pow(i.height - e, 2))
        } ], c = l.filter(t => !this._checkOverlap({
          x: t.x,
          y: t.y,
          width: s,
          height: o
        }, n)), d = (c.length > 0 ? c : l).reduce((t, e) => t.distance < e.distance ? t : e);
        h = d.x, a = d.y, r = d.name + "-corner";
      }
      return {
        position: "adaptive",
        x: h,
        y: a,
        strategy: r
      };
    }
  }
  class e {
    applyPosition(t, e) {
      t && e && Object.assign(t.style, {
        position: "fixed",
        left: `${Math.round(e.x)}px`,
        top: `${Math.round(e.y)}px`,
        zIndex: "2147483647"
      });
    }
    clearPosition(t) {
      t && [ "position", "left", "top", "zIndex" ].forEach(e => {
        t.style.removeProperty(e);
      });
    }
  }
  class i {
    constructor(i = 15) {
      this.calculator = new t(i), this.domPositioner = new e, this.defaultDimensions = {
        width: 400,
        height: 600
      }, this.lastElement = null;
    }
    findGorgiasElement() {
      const t = [ '.gorgias-chat-container iframe#chat-window[class*="gorgias-chat-key-"]', ".gorgias-chat-container iframe#chat-window", '#chat-window[class*="gorgias-chat-key-"]', ".gorgias-chat-container iframe", "iframe#chat-window" ];
      for (const e of t) {
        const t = document.querySelector(e);
        if (t && "IFRAME" === t.tagName) return t;
      }
      return null;
    }
    async waitForElement() {
      for (let t = 0; t < 20; t++) {
        const t = this.findGorgiasElement();
        if (t) return t;
        await new Promise(t => setTimeout(t, 100));
      }
      throw new Error("Gorgias element not found");
    }
    async positionChat(t) {
      if (!t) return null;
      if (window.innerWidth <= 1024) return {
        success: !0,
        position: null,
        skipped: !0,
        reason: "mobile-fullscreen"
      };
      try {
        const e = await this.waitForElement(), i = e.getBoundingClientRect(), s = {
          width: i.width || this.defaultDimensions.width,
          height: i.height || this.defaultDimensions.height
        }, o = this.calculator.calculateOptimalPosition(t, s);
        return o ? (this.domPositioner.applyPosition(e, o), this.lastElement = e, {
          success: !0,
          position: o,
          element: e
        }) : null;
      } catch (t) {
        return console.error("[GorgiasPositioner] Error:", t), {
          success: !1,
          error: t.message
        };
      }
    }
    resetPosition() {
      this.lastElement && (this.domPositioner.clearPosition(this.lastElement), this.lastElement = null);
    }
  }
  new i;
  (() => {
    const t = "help-chat";
    if (!customElements.get(t)) {
      class e extends HTMLElement {
        constructor() {
          super(), this.tabletMQ = window.matchMedia("(max-width: 1024px)"), this.observer = null, 
          this.buttonEl = this.querySelector("button"), this.isOpen = !1, this.offsetStack = {}, 
          this.offsetPriority = [], this.gorgiasPositioner = new i(15), this.handleClick = this.handleClick.bind(this), 
          this.handleMediaQueryChange = this.handleMediaQueryChange.bind(this), this.handleFooterLogoDisplay = this.handleFooterLogoDisplay.bind(this), 
          this.handleIntersection = this.handleIntersection.bind(this), this.handleNudge = this.handleNudge.bind(this), 
          this.handleClickOutside = this.handleClickOutside.bind(this), this.handleGorgiasClose = this.handleGorgiasClose.bind(this);
        }
        async connectedCallback() {
          if (this.buttonEl) {
            this.setupEventListeners();
            try {
              await this.waitForGorgias(), this.initialize();
            } catch (t) {
              console.error("HelpChat: Initialization failed.", t), this.classList.add("hidden");
            }
          }
        }
        setupEventListeners() {
          this.buttonEl.addEventListener("click", this.handleClick), this.tabletMQ.addEventListener("change", this.handleMediaQueryChange), 
          document.addEventListener("help-chat:position", this.handleNudge), document.addEventListener("global-ui:bottom-right-nudge", this.handleNudge), 
          document.addEventListener("cart:open", () => this.classList.add("tablet:opacity-0", "tablet:pointer-events-none")), 
          document.addEventListener("cart:close", () => this.classList.remove("tablet:opacity-0", "tablet:pointer-events-none")), 
          [ "open", "close", "toggle" ].forEach(t => {
            document.addEventListener(`help-chat:${t}`, e => this.handleExternalAction(t, e));
          });
        }
        handleGorgiasClose() {
          requestAnimationFrame(() => {
            "undefined" == typeof GorgiasChat || GorgiasChat.isOpen() || (this.isOpen = !1, 
            this.buttonEl.setAttribute("aria-expanded", "false"), this.gorgiasPositioner.resetPosition(), 
            document.removeEventListener("click", this.handleClickOutside, !0));
          });
        }
        _dispatchEvent(t, e) {
          document.dispatchEvent(new CustomEvent(t, {
            detail: e
          }));
        }
        _relayNudge(t, e) {
          this._dispatchEvent("global-ui:bottom-right-nudge", {
            source: t,
            transform: e,
            target: "all"
          });
        }
        _dispatchSiblingNudge(t) {
          this._dispatchEvent("global-ui:bottom-right-nudge", {
            source: "help-chat-presence",
            isSibling: !0,
            transform: t,
            target: "loading-spinner"
          });
        }
        notifySiblingsOfPresence(t) {
          if (!t) return void this._dispatchSiblingNudge("");
          const e = this.tabletMQ.matches ? `translateX(-${this.buttonEl.offsetWidth + 20}px)` : `translateY(-${this.buttonEl.offsetHeight + 20}px)`;
          this._dispatchSiblingNudge(e);
        }
        handleNudge(t) {
          const {source: e = "global", transform: i, target: s} = t.detail || {};
          s && "help-chat" !== s && "all" !== s || (this._processTransformUpdate(e, i), this._renderTransform());
        }
        handleExternalAction(t) {
          if ("undefined" == typeof GorgiasChat) return;
          const e = {
            open: () => this.openChat(),
            close: () => this.closeChat(),
            toggle: () => this.isOpen ? this.closeChat() : this.openChat()
          };
          e[t]?.();
        }
        handleClickOutside(t) {
          if (!this.isOpen) return;
          const e = this.gorgiasPositioner.findGorgiasElement();
          if (!e) return;
          const i = e => t.clientX < e.left || t.clientX > e.right || t.clientY < e.top || t.clientY > e.bottom;
          i(e.getBoundingClientRect()) && i(this.buttonEl.getBoundingClientRect()) && this.closeChat();
        }
        async openChat() {
          try {
            GorgiasChat.open(), this.isOpen = !0, this.buttonEl.setAttribute("aria-expanded", "true"), 
            await this.gorgiasPositioner.positionChat(this.buttonEl), setTimeout(() => {
              document.addEventListener("click", this.handleClickOutside, !0);
            }, 100);
          } catch (t) {
            console.error("[HelpChat] Error opening chat:", t);
          }
        }
        closeChat() {
          GorgiasChat.close(), this.isOpen = !1, this.buttonEl.setAttribute("aria-expanded", "false"), 
          this.gorgiasPositioner.resetPosition(), document.removeEventListener("click", this.handleClickOutside, !0);
        }
        _processTransformUpdate(t, e) {
          if ("" === e || null === e) {
            delete this.offsetStack[t];
            const e = this.offsetPriority.indexOf(t);
            e > -1 && this.offsetPriority.splice(e, 1);
          } else {
            this.offsetStack[t] = e;
            const i = this.offsetPriority.indexOf(t);
            i > -1 && this.offsetPriority.splice(i, 1), this.offsetPriority.push(t);
          }
        }
        _renderTransform() {
          const t = this.offsetPriority[this.offsetPriority.length - 1], e = t ? this.offsetStack[t] : "", i = "RESET" === e ? "" : e;
          this.buttonEl.style.transform = i.trim() || "none", this.buttonEl.style.transition = "transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)", 
          this.classList.contains("block") && this.notifySiblingsOfPresence(!0);
        }
        handleClick() {
          this.handleExternalAction("toggle");
        }
        waitForGorgias() {
          return new Promise((t, e) => {
            const i = setTimeout(() => e(new Error("Gorgias Timeout")), 1e4), s = () => {
              clearTimeout(i), Promise.resolve(window.GorgiasChat.init()).then(t).catch(e);
            };
            window.GorgiasChat?.init ? s() : window.addEventListener("gorgias-widget-loaded", s, {
              once: !0
            });
          });
        }
        initialize() {
          this.classList.replace("hidden", "block"), this.handleMediaQueryChange(), this.notifySiblingsOfPresence(!0), 
          "undefined" != typeof GorgiasChat && GorgiasChat.on("widget:closed", this.handleGorgiasClose);
        }
        handleMediaQueryChange() {
          this.tabletMQ.matches ? (this.destroyDesktop(), this.setupTablet()) : (this.destroyTablet(), 
          this.setupDesktop()), this.classList.contains("block") && this.notifySiblingsOfPresence(!0);
        }
        _calculateFooterTransform(t = "translateY(-220px)", e = null) {
          const i = e || document.querySelector("[data-footer-bottom]");
          if (i) {
            const t = i.getBoundingClientRect(), s = e ? 20 : 0;
            return `translateY(-${window.innerHeight - t.top + s}px)`;
          }
          return t;
        }
        setupDesktop() {
          window.addEventListener("footer-logo-display", this.handleFooterLogoDisplay);
        }
        destroyDesktop() {
          window.removeEventListener("footer-logo-display", this.handleFooterLogoDisplay);
        }
        setupTablet() {
          const t = document.querySelector("footer .footer__large-logo");
          t && (this.observer = new IntersectionObserver(this.handleIntersection, {
            threshold: .1
          }), this.observer.observe(t));
        }
        destroyTablet() {
          this.observer && this.observer.disconnect();
        }
        handleFooterLogoDisplay(t) {
          const e = t.detail.visible ? this._calculateFooterTransform() : "";
          this._relayNudge("footer-logo", e);
        }
        handleIntersection(t) {
          if (t[0]) {
            const e = t[0].target, i = t[0].isIntersecting ? this._calculateFooterTransform("translateY(-80px)", e) : "";
            this._relayNudge("tablet-intersection", i);
          }
        }
        disconnectedCallback() {
          this.notifySiblingsOfPresence(!1), this.tabletMQ.removeEventListener("change", this.handleMediaQueryChange), 
          this.buttonEl.removeEventListener("click", this.handleClick), document.removeEventListener("help-chat:position", this.handleNudge), 
          document.removeEventListener("global-ui:bottom-right-nudge", this.handleNudge), 
          document.removeEventListener("click", this.handleClickOutside, !0), "undefined" != typeof GorgiasChat && GorgiasChat.off("widget:closed", this.handleGorgiasClose), 
          this.gorgiasPositioner.resetPosition(), this.destroyDesktop(), this.destroyTablet();
        }
      }
      customElements.define(t, e);
    }
  })();
}();